import React from 'react';
import { FormattedNumber } from 'react-intl';

import { Table as AntdTable } from 'antd';
import type { ColumnsType } from 'antd/es/table';

import type { IPartnerDetailsCommissions } from 'v2/interfaces/reports/partnerCommissions';

interface IProps {
  commissions: IPartnerDetailsCommissions[];
}

const columns: ColumnsType<IPartnerDetailsCommissions> = [
  {
    title: 'Produto',
    key: 'product',
    align: 'left',
    render: (_, record) => `${record.product.id} - ${record.product.title}`
  },
  {
    title: 'Comissões',
    dataIndex: 'total_commissions',
    key: 'total_commissions',
    align: 'left'
  },
  {
    title: 'Ganho líquido',
    key: 'net_gain',
    align: 'right',
    width: 160,
    className: 'pr-15',
    onHeaderCell: () => ({ className: 'pr-15' }),
    render: (_, record) => <FormattedNumber value={record.net_gain} format='BRL' />
  }
];

export const Table = ({ commissions }: IProps) => {
  return (
    <div className='mt-6'>
      <AntdTable<IPartnerDetailsCommissions>
        size='small'
        sticky
        className='[&_.ant-table-tbody_.ant-typography]:text-sm'
        columns={columns}
        dataSource={commissions ?? []}
        pagination={false}
        rowKey={record => record.product.id}
        scroll={{ x: 'max-content', y: 348 }}
      />
    </div>
  );
};
